import React, { useEffect } from "react";
import { Button, Checkbox, Form, Input } from "antd";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import setAuthToken from "../util/setAuthToken";
import jwt_decode from "jwt-decode";
import logo from "assets/logo.jpg";

import { loginUser } from "../appRedux/actions/AuthActions";

const FormItem = Form.Item;

class SignIn extends React.Component {
  state = {
    errors: {},
    disabled: false,
    isSubmitting: false, // Add this to prevent double submission
  };
  componentDidMount() {
    console.log("is auth");
    console.log(this.props.auth);
    if (this.props.auth.isAuthenticated) {
      this.redirectUser(this.props.auth.user);
    }
  }

  componentWillReceiveProps(nextProps) {
    console.log(nextProps);
    if (nextProps.auth.isAuthenticated) {
      this.redirectUser(nextProps.auth.user);
    }

    if (nextProps.errors) {
      this.setState({
        errors: nextProps.errors,
        isSubmitting: false, // Reset submitting state on error
      });
    }
  }
  redirectUser = (user) => {
    if (user.role === "admin") {
      this.props.history.push("/admin/dashboard");
    } else if (user.role === "doctor" || user.role === "doctorNurse") {
      this.props.history.push("/doctor/verification");
    } else if (user.role === "practice" || user.role === "practiceNurse") {
      this.props.history.push("/practice/verification");
    } else {
      this.props.history.push("/sale/dashboard");
    }
  };

  handleSubmit = (e) => {
    // Prevent double submission
    if (this.state.isSubmitting) {
      return;
    }

    this.setState({
      disabled: true,
      isSubmitting: true,
    });

    const last2FAAuth = localStorage.getItem("last2FAAuth");
    let is2FARequired = false;

    if (last2FAAuth) {
      const lastAuthDate = new Date(last2FAAuth);
      const currentDate = new Date();
      const diffDays = (currentDate - lastAuthDate) / (1000 * 60 * 60 * 24);
      is2FARequired = diffDays > 14;
    } else {
      is2FARequired = true;
    }

    // Add timeout to reset submitting state if request takes too long
    setTimeout(() => {
      if (this.state.isSubmitting) {
        this.setState({ isSubmitting: false, disabled: false });
      }
    }, 10000); // 10 second timeout

    this.props.loginUser(e, this.props.history, is2FARequired);
  };

  handleChange = (e) => {
    if (this.state.disabled && !this.state.isSubmitting) {
      this.setState({ disabled: false });
    }
  };

  render() {
    return (
      <div className="gx-app-login-wrap" style={{ marginTop: "15%" }}>
        <div className="gx-app-login-container">
          <div className="gx-app-login-main-content">
            <div className="gx-app-logo-content">
              <div className="gx-app-logo-content-bg">
                {window.location.hostname == "portal.femmegen.health" && (
                  <img
                    src={
                      "https://s3.us-east-2.wasabisys.com/medshipohio/Static/FemmGen-Yellow-Wings.png"
                    }
                    alt="Neature"
                  />
                )}
                {window.location.hostname == "portal.powderm.health" && (
                  <img
                    src={
                      "https://s3.us-east-2.wasabisys.com/medshipohio/Static/powderm.jpg"
                    }
                    alt="Neature"
                  />
                )}
                {window.location.hostname == "portal.medship.health" && (
                  <img src={logo} alt="Neature" />
                )}
              </div>
              <div className="gx-app-logo-wid"></div>
            </div>

            <div className="gx-app-login-content">
              <Form
                onFinish={this.handleSubmit}
                className="gx-signin-form gx-form-row0"
              >
                <FormItem
                  name="email"
                  onChange={this.handleChange}
                  rules={[
                    {
                      required: true,
                      type: "email",
                      message: "The input is not valid E-mail!",
                    },
                  ]}
                >
                  <Input name="email" placeholder="Email" />
                </FormItem>
                <FormItem
                  name="password"
                  rules={[
                    { required: true, message: "Please input your Password!" },
                  ]}
                >
                  <Input
                    type="password"
                    name="password"
                    placeholder="Password"
                    onChange={this.handleChange}
                  />
                </FormItem>
                <Link
                  to="/forgot"
                  style={{ marginTop: 20, marginBottom: 20, padding: 10 }}
                >
                  <span>Forgot Your Password ?</span>
                </Link>
                <FormItem>
                  <Button
                    type="primary"
                    style={{ marginTop: 20, marginBottom: 20 }}
                    className="gx-mb-0"
                    htmlType="submit"
                    disabled={this.state.disabled || this.state.isSubmitting}
                    loading={this.state.isSubmitting}
                  >
                    {this.state.isSubmitting ? "Signing In..." : "Sign In"}
                  </Button>
                </FormItem>
              </Form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.authR,
  errors: state.errors,
});
export default connect(mapStateToProps, {
  loginUser,
})(SignIn);
